(() => {
  const dialog = document.querySelector('#MatildeWelcome');
  if (!dialog || dialog.dataset.initialized || location.pathname === '/challenge') return;
  dialog.dataset.initialized = 'true';
  const seenKey = 'matilde-welcome-seen-v2', dueKey = 'matilde-welcome-due-v3', pendingKey = 'matilde-welcome-pending-v1';
  const read = key => { try { return localStorage.getItem(key) || sessionStorage.getItem(key); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) { try { sessionStorage.setItem(key, value); } catch (_) {} } };
  let pending = false;
  try { pending = sessionStorage.getItem(pendingKey) === 'true'; } catch (_) {}
  let timer, opener;
  const recentlySeen = () => Date.now() - Number(read(seenKey) || 0) < 30 * 24 * 60 * 60 * 1000;
  const show = reward => {
    if (dialog.open) return;
    opener = document.activeElement;
    dialog.querySelector('[data-mw-offer]').hidden = reward;
    dialog.querySelector('[data-mw-reward]').hidden = !reward;
    dialog.setAttribute('aria-labelledby', reward ? 'mw-reward-title' : 'mw-title');
    if (reward) dialog.removeAttribute('aria-describedby');
    dialog.showModal();
    document.documentElement.classList.add('mw-open');
    write(seenKey, String(Date.now()));
    dialog.querySelector(reward ? '[data-mw-copy]' : '[data-mw-close]').focus({ preventScroll: true });
  };
  const attempt = () => {
    if (recentlySeen()) return;
    const cookieBannerVisible = [...document.querySelectorAll('#shopify-pc__banner,[data-matilde-cookie]:not([hidden])')].some(banner => banner.getClientRects().length && getComputedStyle(banner).visibility !== 'hidden');
    if (document.hidden || document.querySelector('dialog[open],.matilde-cookie-open') || cookieBannerVisible) {
      write(dueKey, String(Date.now() + 7000));
      timer = setTimeout(attempt, 500); return;
    }
    const remaining = Number(read(dueKey)) - Date.now();
    if (remaining > 0) { timer = setTimeout(attempt, remaining); return; }
    show(false);
  };
  const schedule = () => {
    clearTimeout(timer);
    if (recentlySeen()) return;
    let due = Number(read(dueKey));
    if (!due) { due = Date.now() + 7000; write(dueKey, String(due)); }
    timer = setTimeout(attempt, Math.max(0, due - Date.now()));
  };
  dialog.querySelectorAll('[data-mw-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('mw-open'); opener?.focus?.({ preventScroll: true }); });
  dialog.addEventListener('click', event => { if (event.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); });
  dialog.querySelector('form').addEventListener('submit', () => {
    try { sessionStorage.setItem(pendingKey, 'true'); } catch (_) {}
  });
  dialog.querySelector('[data-mw-copy]').addEventListener('click', async () => {
    const status = dialog.querySelector('[data-mw-copy-status]');
    try { await navigator.clipboard.writeText('VELKOMMEN10'); status.textContent = 'Koden er kopiert!'; }
    catch (_) { status.textContent = 'Marker og kopier koden VELKOMMEN10.'; }
  });
  const success = dialog.querySelector('[data-mw-success]')?.dataset.mwSuccess === 'true';
  if (pending && (success || dialog.querySelector('[data-mw-error]'))) {
    if (success) { try { sessionStorage.removeItem(pendingKey); } catch (_) {} }
    show(success);
  }
  document.addEventListener('visitorConsentCollected', schedule);
  window.addEventListener('storage', event => { if (event.key === seenKey) { clearTimeout(timer); if (dialog.open) dialog.close(); } });
  schedule();
})();
